import React from "react";
import loginService from "../services/login";
import Cookies from "universal-cookie";

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    case "LOGIN_FAILURE":
      return { ...state, isAuthenticated: false };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, signOut };

// ###########################################################

async function loginUser(
  dispatch,
  login,
  password,
  history,
  setIsLoading,
  setError
) {
  setError(false);
  setIsLoading(true);

  if (!!login && !!password) {
    const resp = await loginService(login, password);
    if (
      resp.user === null ||
      resp.token === null ||
      (resp.user.type != 0 && resp.user.type != 4)
    ) {
      dispatch({ type: "LOGIN_FAILURE" });
      setError(true);
      setIsLoading(false);
    } else {
      const cookies = new Cookies();
      cookies.set("token", resp.token, { path: "/" });
      cookies.set("username", resp.user.username, { path: "/" });
      cookies.set("adminId", resp.user.id, { path: "/" });
      cookies.set("userType", resp.user.type, { path: "/" });
      cookies.set("userId", resp.user.user_id, { path: "/" });

      setError(null);
      setIsLoading(false);
      dispatch({ type: "LOGIN_SUCCESS" });
      window.location.href = "/";

      if (resp.user.username == "admin") history.push("/app/corsi");
      else if (resp.user.username == "billing") history.push("/billing/corsi");
      else if (resp.user.username == "phoneop") history.push("/app/dachiamare");
    }
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  const cookies = new Cookies();
  cookies.set("token", "", { path: "/" });
  cookies.set("currentEventName", "", { path: "/" });
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  window.location.href = "/";
  history.push("/login");
}
